import { createMuiTheme } from '@material-ui/core/styles';
import { muiThemeMaster, masterTheme } from './theme';

const defaultTheme = createMuiTheme();

const loginTheme = {
  overrides: {
    ...masterTheme.overrides,
    MuiFormControl: {
      root: {
        width: '100%',
      },
    },
    MuiFormLabel: {
      root: {
        // color: 'white',
        fontSize: '24px',
        [defaultTheme.breakpoints.down('xs')]: {
          fontSize: '16px',
        },
        fontWeight: 'bold',
        textTransform: 'uppercase',
      },
    },
    MuiInputLabel: {
      formControl: {
        position: 'static',
        marginTop: 0,
      },
    },
    MuiInputBase: {
      root: {
        borderColor: 'white',
      },
      input: {
        color: 'black',
        // color: 'white',
        fontSize: '24px',
        padding: 0,
      },
      formControl: {
        padding: 0,
      },
    },
    MuiInput: {
      borderBottom: `2px solid #4D4D4D`,
      underline: {
        '&:hover:not($disabled):not($focused):not($error):before': {
          borderBottom: `2px solid lightgrey`,
          // borderBottom: `2px solid white`,
        },
      },
      formControl: {
        'label + &': {
          marginTop: 0,
        },
      },
    },
  },
};

export const loginThemeExport = width =>
  createMuiTheme({ ...muiThemeMaster(width), ...loginTheme });
